// File for logic corresponding to footer component
import './footer.scss';
